app.controller("GroupPostsIndexController", [
    "$scope", "StaticData", "Lecturer", "Session", "$uibModal", "$httpParamSerializer", "$stateParams", "$state", "toastr", "usSpinnerService",
    function ($scope, StaticData, Lecturer, Session, $uibModal, $httpParamSerializer, $stateParams, $state, toastr, usSpinnerService) {
        $scope.groupPosts = [];
        $scope.totalItems = 0;
        $scope.itemsPerPage = $stateParams.limit || 20;
        $scope.lecturerId = $stateParams.lecturer;

        $scope.formatTime = "hh:mm";
        $scope.formatWithTime = "dd-MM-yyyy hh:mm";

        $scope.sessionTypeText = function(type){
            return type === 'lecture' ? 'ლექცია' : 'სემინარი';
        };

        $scope.lastPost = function(element){
            return element.sessionGroup.lastPost.length ? element.sessionGroup.lastPost[0] : null;

        };

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        if($stateParams.lecturer) {
            Lecturer.fetchOne($stateParams.lecturer).then(function (data) {
                $scope.lecturer = data;
            });
        }

        $scope.getLecturers = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Lecturer.list({query: query}).then(function (data) {
                return data.docs;
            });
        };

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        function loadPage(page, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");
            Session.sessionGroupPosts({
                lecturer: $scope.lecturerId,
                page: $scope.page,
                limit:  $scope.itemsPerPage
            }).then(function (data) {
                $scope.totalItems = data.total;
                $scope.groupPosts = data.docs;
                usSpinnerService.stop("root");
                cb()
            });
        }

        $scope.applyFilter = function () {
            var query = {
                page: $scope.page,
                limit:  $scope.itemsPerPage
            };

            if($scope.lecturer &&$scope.lecturer._id ) {
                query.lecturer = $scope.lecturer._id;
            }

            $state.go(".", query);
        };

        $scope.export = function () {
            var query = {
                page: $scope.page,
                limit:  $scope.itemsPerPage
            };

            if($scope.lecturer &&$scope.lecturer._id ) {
                query.lecturer = $scope.lecturer._id;
            }
            var qs = $httpParamSerializer(query);
            window.open('/session/group/posts/export?' + qs);
        }
    }
]);
